import { Style } from 'inlines'

export type Typography =
  | 'title'
  | 'subtitle'
  | 'heading'
  | 'heading-bold'
  | 'subheading-regular'
  | 'subheading-medium'
  | 'subheading-bold'
  | 'display-regular'
  | 'display-medium'

const INTER_REGULAR_FONT =
  '"Inter","Geist",-apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Cantarell","Fira Sans","Droid Sans","Helvetica Neue",sans-serif'

export const TEXT_VARIANT_STYLES: Record<Typography, Style> = Object.freeze({
  title: {
    fontFamily: INTER_REGULAR_FONT,
    fontSize: '36px',
    fontWeight: 700,
    lineHeight: 'normal',
    letterSpacing: '-0.72px',
    '@media (max-width: 428px)': {
      fontSize: '30px',
    },
    '@media (max-width: 376px)': {
      fontSize: '26px',
    },
  },
  subtitle: {
    fontFamily: INTER_REGULAR_FONT,
    fontSize: '24px',
    fontWeight: 600,
    lineHeight: 'normal',
    letterSpacing: '-0.48px',
    whiteSpace: 'normal',
  },
  heading: {
    fontFamily: INTER_REGULAR_FONT,
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: 'normal',
    letterSpacing: '0px',
  },
  'heading-bold': {
    fontFamily: INTER_REGULAR_FONT,
    fontSize: '18px',
    fontWeight: 700,
    lineHeight: 'normal',
    letterSpacing: '0px',
  },
  'subheading-regular': {
    fontFamily: INTER_REGULAR_FONT,
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: '0px',
  },
  'subheading-medium': {
    fontFamily: INTER_REGULAR_FONT,
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0px',
  },
  'subheading-bold': {
    fontFamily: INTER_REGULAR_FONT,
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '24px',
    letterSpacing: '0px',
  },
  'display-regular': {
    fontFamily: INTER_REGULAR_FONT,
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: 'normal',
    letterSpacing: '0px',
  },
  'display-medium': {
    fontFamily: INTER_REGULAR_FONT,
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0px',
  },
})
